/**
 * 退费信息路由
 */
const RefundRouter = {
  path: 'refund',
  name: 'Refund',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Refund/index')
}
export default RefundRouter
